import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Arial',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          textTransform: 'initial',
          boxShadow: 'none',
          border: 'none',
          '&:hover': {
            boxShadow: 'none',
            border: 'none',
          },
        },
        sizeLarge: {
          fontSize: 21,
        },
      },
      defaultProps: {
        disableElevation: true,
        variant: 'contained',
      },
      variants: [
        {
          props: { variant: 'gradient' }, // nova variant
          style: {
            background: 'linear-gradient(to right, #00D160, #0091EA)',
            color: '#fff',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: 16,
            borderRadius: 10,
            '&:hover': {
              background: 'linear-gradient(to right, #00C150, #0078D4)',
            },
          },
        },
        {
          props: { variant: 'gradient2' },
          style: {
            background: 'linear-gradient(to right, #0078D4,#158eeb)',
            color: '#fff',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: 16,
            borderRadius: 10,
            '&:hover': {
              background: 'linear-gradient(to right,#0065b1,#2398f1)',
            },
          },
        },
      ],
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          borderRadius: '12px !important',
          color: '#2D354A',
          // height: 60,
          // fontSize: 24,
          // fontWeight: 'bold',
          borderColor: '#B3BCCC',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#00D160',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0093FF',
      contrastText: '#FFFFFF',
    },
    bg: {
      main: '#2D354A',
    },
    featured: {
      main: '#191B27',
    },
    white: {
      main: '#FFFFFF',
      contrastText: '#FFFFFF',
    },
    soft: {
      main: '#DCE4F2',
    },
  },
});

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    colored: true;
    gradient: true;
    gradient2: true;
  }
  interface ButtonPropsColorOverrides {
    white: true;
    bg: true;
    featured: true;
    soft: true;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    white: true;
    bg: true;
    featured: true;
    soft: true;
  }
}
declare module '@mui/material/styles' {
  interface Palette {
    bg: Palette['primary'];
    featured: Palette['primary'];
    white: '#ffffff';
    soft: Palette['primary'];
  }

  interface PaletteOptions {
    bg?: PaletteOptions['primary'];
    featured?: PaletteOptions['primary'];
    white?: PaletteOptions['primary'];
    soft?: PaletteOptions['primary'];
  }
}
